import { render, staticRenderFns } from "./datajob__form.vue?vue&type=template&id=6ba17ed0"
import script from "./datajob__form.vue?vue&type=script&lang=js"
export * from "./datajob__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports